export const ROOT_PATH = '/'
export const CONFIGURATIONS_PATH = '/configurations'
export const VERSIONS_PATH = '/versions'
export const LOGIN_PATH = '/login'
